import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { LogIn, Loader2 } from "lucide-react";

export default function MemberLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user && user.role === "member") navigate("/espace-membre", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/espace-membre", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="member-login-page" className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-center bg-brand-blue text-white p-16">
        <img src={LOGO_URL} alt="DEFAR" className="h-16 w-16 bg-white p-1 rounded-full" />
        <h1 className="mt-8 text-4xl font-bold leading-tight">DEFAR & Moi</h1>
        <p className="mt-4 text-blue-100 text-lg max-w-md">Votre espace membre : carte digitale, événements, contributions et documents du mouvement.</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-brand-surface">
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-bold text-slate-900">Connexion membre</h2>
          <p className="mt-2 text-slate-500 text-sm">Accédez à votre espace « DEFAR & Moi ».</p>
          <form onSubmit={submit} className="mt-8 bg-white border border-border rounded-sm p-7 space-y-5">
            {error && <div data-testid="member-login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-sm">{error}</div>}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="member-login-email" className="w-full border border-border px-4 py-2.5 rounded-sm text-sm focus:outline-none focus:border-brand-blue" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">Mot de passe</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="member-login-password" className="w-full border border-border px-4 py-2.5 rounded-sm text-sm focus:outline-none focus:border-brand-blue" />
            </div>
            <button type="submit" disabled={loading} data-testid="member-login-submit" className="w-full flex items-center justify-center gap-2 bg-brand-green text-white hover:bg-brand-greenhover transition-colors py-3 font-semibold disabled:opacity-60">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <LogIn size={16} />} {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
          <p className="mt-6 text-sm text-slate-600 text-center">
            Pas encore membre ? <Link to="/espace-membre/inscription" className="text-brand-blue font-semibold">Créer mon compte</Link>
          </p>
          <p className="mt-2 text-center"><Link to="/" className="text-xs text-slate-400 hover:text-slate-600">← Retour au site</Link></p>
        </div>
      </div>
    </div>
  );
}
